import React from 'react';

import { useField } from 'formik';

import classNames from 'classnames';

import { Input } from '../../../../../Common';

import './index.scss';

const MutatePionYoutubeContent = ({ name, ...props }) => {
  const [field, { error }] = useField(name);

  return (
    <Input
      {...props}
      {...field}
      className={classNames(
        'mutate-pion-youtube-content',
        { 'mutate-pion-youtube-content-error': error },
        props.className,
      )}
      type="url"
      placeholder="URL"
    />
  );
};

export default MutatePionYoutubeContent;
